module.exports = __webpack_public_path__ + "img/9348.99fcceef.jpg";